export default __webpack_public_path__ + "static/media/plate3.16e9573f.png";